// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3j-WV","colMin":"styles_colMin__2zqEH"};